import { url } from '../../axios/api_urls/marketOverview'
import utils from '@/utils'
import {getDictionary} from "../../axios/api/dictionary";
const api = require('../../axios/request')

const UPDATE_STATE = 'UPDATE_STATE'
const state = {
  segment: [],
  marketSegment: [],
  subSegment: [],
  country: [],
  year: [],
  currentYear: {},
  yearList: [], // 比如十大公司这种年份只到2017，后台传了是什么就是什么
  targetYear: {}, // 比如十大公司这种年份只到2017，后台传了是什么就是什么
  targetCountry: {},
  // 亚太视图右边的13个蓝色可选项
  asiaPacific: [
    {
      cnName: '中国',
      enName: 'China',
      code: 'PRC'
    },
    {
      cnName: '韩国',
      enName: 'Korea',
      code: 'KOR'
    },
    {
      cnName: '菲律宾',
      enName: 'Philippines',
      code: 'PHL'
    },
    {
      cnName: '日本',
      enName: 'Japan',
      code: 'JPN'
    },
    {
      cnName: '马来西亚',
      enName: 'Malaysia',
      code: 'MYS'
    },
    {
      cnName: '印度',
      enName: 'India',
      code: 'IND'
    },
    {
      cnName: '印度尼西亚',
      enName: 'Indonesia',
      code: 'IDN'
    },
    {
      cnName: '泰国',
      enName: 'Thailand',
      code: 'THA'
    },
    {
      cnName: '新加坡',
      enName: 'Singapore',
      code: 'SGP'
    },
    {
      cnName: '新西兰',
      enName: 'New Zealand',
      code: 'NZL'
    },
    {
      cnName: '越南',
      enName: 'Vietnam',
      code: 'VNM'
    },
    {
      cnName: '澳大利亚',
      enName: 'Australia',
      code: 'AUS'
    },
    {
      cnName: '巴基斯坦',
      enName: 'Pakistan',
      code: 'PAK'
    }
  ],
  // 亚太视野
  overview: [],
  overviewTitle: '',
  // 十大品牌
  brandSalesVolume: [],
  brandSalesVolumeTitle: '',
  // 公司品牌绩效
  brandCagr: [],
  brandCagrTitle: '',
  // 市场分区销售量
  yearSalesVolume: [],
  yearSalesVolumeTitle: '',
  // 二级市场分区销售量
  subYearSalesVolume: [],
  subYearSalesVolumeTitle: ''
}
const getters = {
  segment: state => state.segment,
  marketSegment: state => state.marketSegment,
  subSegment: state => state.subSegment,
  country: state => state.country,
  year: state => state.year,
  yearList: state => state.yearList,
  currentYear: state => state.currentYear,
  targetYear: state => state.targetYear,
  targetCountry: state => state.targetCountry,
  asiaPacific: state => state.asiaPacific,
  overview: state => state.overview,
  overviewTitle: state => state.overviewTitle,
  brandSalesVolume: state => state.brandSalesVolume,
  brandSalesVolumeTitle: state => state.brandSalesVolumeTitle,
  brandCagr: state => state.brandCagr,
  brandCagrTitle: state => state.brandCagrTitle,
  yearSalesVolume: state => state.yearSalesVolume,
  yearSalesVolumeTitle: state => state.yearSalesVolumeTitle,
  subYearSalesVolume: state => state.subYearSalesVolume,
  subYearSalesVolumeTitle: state => state.subYearSalesVolumeTitle
}
const mutations = {
  [UPDATE_STATE] (state, params) {
    state[params.key] = params.value
  }
}
const actions = {
  getYear ({commit, dispatch}, payload) {
    return api._post(url.year, {yearType: 1}).then(res => {
      commit(UPDATE_STATE, {key: 'year', value: res.data || []})
      dispatch('getTargetYear', 'year')
    })
  },
  getYearList ({commit, dispatch}, payload) {
    return api._post(url.year, {yearType: 0}).then(res => {
      commit(UPDATE_STATE, {key: 'yearList', value: res.data || []})
      dispatch('getTargetYear', 'yearList')
    })
  },
  getTargetYear ({state, commit}, payload) {
    state[payload].some(item => {
      if (item.mark) commit(UPDATE_STATE, {key: 'targetYear', value: item || {}})
    })
  },
  getCountry ({commit, dispatch}, payload) {
    return api._post(url.country).then(res => {
      commit(UPDATE_STATE, {key: 'country', value: res.data || []})
      dispatch('getCurrentCountry')
    })
  },
  getCurrentCountry ({state, commit}) {
    state.country.some(item => {
      if (item.mark) commit(UPDATE_STATE, {key: 'targetCountry', value: item || {}})
    })
  },
  getSegmentList ({commit}, payload) {
    return api._post(url.segment, {pid: payload || 0}).then(res => {
      return payload ? res : commit(UPDATE_STATE, {key: 'segment', value: res.data || []})
    })
  },
  getMarketSegmentList ({commit}, payload) {
    return api._post(url.marketSegment).then(res => {
      return payload ? res : commit(UPDATE_STATE, {key: 'marketSegment', value: res.data || []})
    })
  },
  getBrandCagr ({commit}, payload) {
    return api._post(url.brandCagr, payload).then(res => {
      commit(UPDATE_STATE, {key: 'brandCagr', value: res.data.listData || []})
      commit(UPDATE_STATE, {key: 'brandCagrTitle', value: res.data.tablTitle || ""})
      return res
    })
  },
  getBrandSalesVolume ({commit}, payload) {
    return api._post(url.brandSalesVolume, payload).then(res => {
      commit(UPDATE_STATE, {key: 'brandSalesVolume', value: res.data.listData || []})
      commit(UPDATE_STATE, {key: 'brandSalesVolumeTitle', value: res.data.tablTitle || ""})
      return res
    })
  },
  getOverview ({commit}, payload) {
    return api._post(url.overview, payload).then(res => {
      commit(UPDATE_STATE, {key: 'overview', value: res.data.listData || []})
      commit(UPDATE_STATE, {key: 'overviewTitle', value: res.data.tablTitle || ""})
      return res
    })
  },
  getYearSalesVolume ({commit}, payload) {
    return api._post(url.yearSalesVolume, payload).then(res => {
      commit(UPDATE_STATE, {key: payload.segmentId ? 'subYearSalesVolume' : 'yearSalesVolume', value: res.data.listData || []})
      commit(UPDATE_STATE, {key: payload.segmentId ? 'subYearSalesVolumeTitle' : 'yearSalesVolumeTitle', value: res.data.tablTitle || ""})
      return res
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/marketOverview.js